/**
 * Cart upsell — adds the product picked in Cart section settings > Upsell.
 *
 * The cart drawer replaces its own innerHTML whenever it refreshes, so the
 * click handler is delegated from `document` instead of bound to the button.
 * After adding, the theme's own cart section instance re-fetches /cart, which
 * both redraws the drawer and re-binds its quantity/remove handlers.
 */
(function () {
	'use strict';

	function refreshCart() {
		var instances = (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections && window.Shopify.theme.sections.instances) || [];

		var cartSection = instances.filter(function (instance) {
			return instance.type === 'cart';
		})[0];

		if (cartSection && typeof cartSection.getCart === 'function') {
			return cartSection.getCart();
		}

		// No cart section on this page (or it failed to load): fall back to a reload
		// so the customer still sees the item they just added.
		window.location.reload();
		return Promise.resolve();
	}

	function addToCart(button) {
		var variantId = button.dataset.variantId;

		if (!variantId || button.disabled) {
			return;
		}

		button.disabled = true;
		button.textContent = button.dataset.labelLoading || 'Adding…';

		fetch('/cart/add.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			},
			body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
		})
			.then(function (response) {
				if (!response.ok) {
					throw response;
				}

				return refreshCart();
			})
			.catch(function () {
				button.disabled = false;
				button.textContent = button.dataset.label || 'Add';
			});
	}

	document.addEventListener('click', function (event) {
		var button = event.target.closest('[data-cart-upsell-add]');

		if (!button) {
			return;
		}

		event.preventDefault();
		addToCart(button);
	});
})();
